// extracted by mini-css-extract-plugin
module.exports = {"optionsContainer":"LegacyVariant_optionsContainer__-3b1L","optionItem":"LegacyVariant_optionItem__2ENWE"};